import { Button, Stack } from '@mui/material'
import { PRICING_CONFIG, createAdminRecipe } from 'element-domain'

import { adminInterface } from '../../systems/admin-interface'

const recipes = [
  createAdminRecipe({
    type: 'PricingSettings',
    data: JSON.stringify(PRICING_CONFIG),
  }),
]

export const PricingActionsElement = () => {
  const rootEntityId = adminInterface.useRootEntityId()

  const hasPricing = adminInterface.useStoreSelector(
    emission => emission.state.entities.some(e => e.type === 'PricingSettings'),
    []
  )

  const { create, disabled } = adminInterface.useCookedRecipes(recipes, rootEntityId)

  if (hasPricing) return <></>

  return (
    <Stack direction="row" gap={1}>
      <Button variant="contained" size="small" onClick={create} disabled={disabled}>
        Initialize Pricing
      </Button>
    </Stack>
  )
}
